import { render, staticRenderFns } from "./centered-container.vue?vue&type=template&id=1b06b018&scoped=true&"
import script from "./centered-container.vue?vue&type=script&lang=js&"
export * from "./centered-container.vue?vue&type=script&lang=js&"
import style0 from "./centered-container.vue?vue&type=style&index=0&id=1b06b018&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b06b018",
  null
  
)

export default component.exports